import type { ProgramAIData } from "@/hooks/program/types";

const LEGACY_RESEARCH = "Regenerating...";
const LEGACY_SOCIAL = "Generating...";

export function isResearchGenerating(
  data: ProgramAIData | null | undefined
): boolean {
  if (!data) return false;
  if (data.generating_research_article) return true;
  return data.ai_article === LEGACY_RESEARCH;
}

export function hasResearchArticleContent(
  data: ProgramAIData | null | undefined
): boolean {
  return Boolean(data?.ai_article?.trim()) && data?.ai_article !== LEGACY_RESEARCH;
}

export function isMagazineGenerating(
  data: ProgramAIData | null | undefined
): boolean {
  if (!data) return false;
  if (data.generating_magazine_article) return true;
  return data.ai_magazine_article === LEGACY_RESEARCH;
}

export function hasMagazineArticleContent(
  data: ProgramAIData | null | undefined
): boolean {
  return (
    Boolean(data?.ai_magazine_article?.trim()) &&
    data?.ai_magazine_article !== LEGACY_RESEARCH
  );
}

export function isSocialPostReady(
  value: string | null | undefined
): boolean {
  return Boolean(value?.trim()) && value !== LEGACY_SOCIAL;
}

export function isSocialBatchGenerating(
  data: ProgramAIData | null | undefined
): boolean {
  if (!data) return false;
  if (data.generating_social_media_posts) return true;
  return (
    data.ai_linkedin_post === LEGACY_SOCIAL ||
    data.ai_instagram_post === LEGACY_SOCIAL ||
    data.ai_x_post === LEGACY_SOCIAL ||
    data.ai_threads_post === LEGACY_SOCIAL ||
    data.ai_facebook_post === LEGACY_SOCIAL
  );
}

export function areAllSocialPostsComplete(
  data: ProgramAIData | null | undefined
): boolean {
  if (!data || data.generating_social_media_posts) return false;
  return (
    isSocialPostReady(data.ai_linkedin_post) &&
    isSocialPostReady(data.ai_instagram_post) &&
    isSocialPostReady(data.ai_x_post) &&
    isSocialPostReady(data.ai_threads_post) &&
    isSocialPostReady(data.ai_facebook_post)
  );
}

export function isSummaryGenerating(
  data: ProgramAIData | null | undefined
): boolean {
  return data?.generating_summary === true;
}
